import React from 'react'
import { useLGDetection } from '../../../LG/hooks/useLGDetection'

const AccountMenu = ({
  isAccountMenuVisible,
  toggleAccountModal,
  handleSubscribe,
  handleLogout,
  handleExitToLG
}) => {
  const { isLGSmartTV } = useLGDetection()
  return (
    <div
      className={`desktop-account-pane ${isAccountMenuVisible ? 'active' : ''}`}
    >
      <ul id="view-account-nav" className="shadow04">
        <li className="desktop-account-link01" onClick={toggleAccountModal}>
          View Account
        </li>
        <li
          className="desktop-account-link01 subscribe"
          onClick={handleSubscribe}
        >
          Subscription
        </li>
        <li className="desktop-account-link01" onClick={handleLogout}>
          Sign Out
        </li>
        {isLGSmartTV && ( // Only show the button when on an LG Smart TV
          <li className="exit-to-lg-btn" onClick={handleExitToLG}>
            Exit to LG
          </li>
        )}
      </ul>
    </div>
  )
}

export default AccountMenu
